
export const SET_USER_AUTH = "user/SET_USER_AUTH";
export const SET_PARTNER_CODE = "user/SET_PARTNER_CODE";
export const SET_MOBILE_PAGE = "user/SET_MOBILE_PAGE";
export const LOADER = "LOADER";
export const EXTEND_TIMEOUT = "EXTEND_TIMEOUT";
export const SET_TIMEZONE_OFFSET = "user/SET_TIMEZONE_OFFSET";
export const UPDATE_USERNAME ="user/UPDATE_USERNAME";

export const setUserAuth = ( data, authenticate ) => ({
    type: SET_USER_AUTH,
    payload: data,
    isAuthenticated: authenticate
});

export const hideShowLoader = ( isLoading) => ({
    type: LOADER,
    payload: isLoading
});

export const extendTimeout = ( ) => ({
    type: EXTEND_TIMEOUT
});

export const setPartnerCode = ( data ) => ({
    type: SET_PARTNER_CODE,
    payload: data
});

export const updateUsername = ( data ) => ({
    type: UPDATE_USERNAME,
    payload: data
});

export const setMobilePage = ( data ) => ({
    type: SET_MOBILE_PAGE,
    payload: data
});

export const setTimezoneOffset = ( data ) => ({
    type: SET_TIMEZONE_OFFSET,
    payload: data
});